<!-- <input type="file" id="passport" (change)="onFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" /> -->
<ng-container>
    <div class="step" [ngClass]="{'completed': isFileSelected()}">
      <div class="step-content" style="max-width: 70%;">
        <h4>{{ pickerLabel }}</h4>
        <p *ngIf="isFileSelected()">✅ Archivo cargado: <strong>{{ fileName }}</strong></p>
      </div>
      <button mat-raised-button type="button" color="primary" (click)="fileInput.click()">
        <mat-icon>cloud_upload</mat-icon>
      </button>
      <!-- Hidden Native Input -->
    <input #fileInput type="file" [accept]="formatsAccepted" (change)="handleFileSelection($event)" hidden />
    </div>
    <mat-progress-bar *ngIf="uploadProgress" mode="indeterminate"></mat-progress-bar>
</ng-container>